/**
 * iter165 — Helper unique pour transformer un article (issu d'ArticlePickerDialog)
 * en preset de ligne pour Devis / Facture / OR.
 *
 * Gère :
 *   - Article libre / générique  (article.__generic)  → ligne vide type=libre
 *   - Main d'œuvre forfaitaire   (categorie=main_oeuvre & unite=forfait)
 *       → 1 × prix forfait ; type=forfait ; categorie_mo conservée (calcul heures interne)
 *   - Article standard           → type=article
 *
 * @param {object} article — objet retourné par le picker
 * @param {object} opts
 * @param {"tva_taux"|"tva_pct"} opts.tvaField — clé de TVA (Devis/Facture: tva_taux, OR: tva_pct)
 * @param {number} opts.tvaDefaut — valeur par défaut TVA (8.1)
 * @returns {object} preset ligne prêt à être mergé dans le state parent
 */
export const TAUX_HORAIRE_ATELIER_REFERENCE_HT = 140.0;

export function buildLigneFromArticle(article, { tvaField = "tva_taux", tvaDefaut = 8.1 } = {}) {
  const isGeneric = !!(article && article.__generic);
  if (isGeneric) {
    // iter183 — "Article libre" (sans catalogue) doit tout de même être classé
    // comme un ARTICLE (marchandise) et pas un "champ libre". Ainsi :
    //   - la colonne Type affiche "Article" (au lieu de "Libre")
    //   - la catégorie compta est présélectionnée "marchandises" (3400 Ventes pièces)
    //     sans que l'utilisateur ait à choisir marchandise vs prestations.
    const line = {
      libelle: "",
      quantite: 1,
      prix_unitaire_ht: 0,
      unite: "",
      rabais_pct: 0,
      rabais_chf: 0,
      type_ligne: "article",
      categorie_compta: "marchandises",
      article_id: null,
    };
    line[tvaField] = tvaDefaut;
    return line;
  }

  const isMoForfait = article.categorie === "main_oeuvre"
    && article.unite === "forfait"
    && (article.prix_ht || 0) > 0;

  if (isMoForfait) {
    // iter223 — La ligne reste un forfait à l'affichage (1 × prix). L'équivalent heures
    // est calculé en interne (stats atelier) via categorie_mo + taux horaire du tarif OR.
    const line = {
      libelle: article.libelle,
      quantite: 1,
      prix_unitaire_ht: article.prix_ht || 0,
      unite: "forfait",
      rabais_pct: 0,
      rabais_chf: 0,
      type_ligne: "forfait",
      categorie_mo: article.categorie_mo || "mecanique",
      article_id: article.id,
    };
    line[tvaField] = article.tva_pct ?? article.tva ?? tvaDefaut;
    return line;
  }

  const line = {
    libelle: article.libelle,
    quantite: 1,
    prix_unitaire_ht: article.prix_ht || 0,
    unite: article.unite || "",
    rabais_pct: 0,
    rabais_chf: 0,
    type_ligne: article.categorie === "main_oeuvre" ? "main_oeuvre" : "article",
    article_id: article.id,
  };
  line[tvaField] = article.tva_pct ?? article.tva ?? tvaDefaut;
  return line;
}
